import Vue from "vue"
const getBestLocal = () => {
    for (let key in navigator.languages) {
        let lang = navigator.languages[key]
        if (lang.includes("-")) {
            lang = lang.substring(0, lang.indexOf("-"))
        }
        if (["de", "fr", "en", "nl"].includes(lang)) {
            return lang
        }
    }
    return "en"
}
export default {
    namespaced: true,
    state: {
        locale: getBestLocal(),
        token: null,
        email: null,
        country: null,
        name: null,
        darkMode: false,
        pushNotificationToken: false,
    },
    getters: {
        bestLocal(state) {
            return getBestLocal()
        },
        locale(state) {
            return state.locale
        },
        country(state) {
            return state.country
        },
        token(state) {
            return `Bearer ${state.token}`
        },
        logged(state) {
            return state.token
        },
        name(state) {
            return state.name
        },
        email(state) {
            return state.email
        },
        darkMode(state) {
            return state.darkMode
        },
        pushNotificationToken(state) {
            return state.pushNotificationToken
        },
        fullLocale(state) {
            return `${state.locale}-${state.country}`
        },
    },
    actions: {
        logout({ commit, state, getters }) {
            commit("token", null)
            commit("email", null)
            commit("name", null)
            commit("country", null)
            window.localStorage.clear()
        },
        login({ commit, state }, user) {
            commit("token", user.token)
            commit("locale", user.locale)
            commit("name", user.name)
            commit("email", user.email)
            if (user.address) {
                commit("country", user.address.country)
            }
        },
        setInfo({ commit, state }, user) {
            commit("email", user.email || state.email)
            commit("name", user.name || state.name)
            commit("locale", user.locale || state.locale)
            commit("country", user.address.country || state.country)
        },
    },
    mutations: {
        locale(state, locale) {
            state.locale = locale
        },
        country(state, country) {
            state.country = country
        },
        token(state, token) {
            state.token = token
        },
        role(state, role) {
            state.role = role
        },
        email(state, email) {
            state.email = email
        },
        name(state, name) {
            state.name = name
        },
        darkMode(state, darkMode) {
            state.darkMode = darkMode
        },
        pushNotificationToken(state, pushNotificationToken) {
            state.pushNotificationToken = pushNotificationToken
        },
    },
}
